
import 'tailwindcss/tailwind.css';
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarDays, faChampagneGlasses, faChurch} from '@fortawesome/free-solid-svg-icons'


function Ubicacion() {
    const handleButtonClick = () => {
      window.location.href = "https://maps.app.goo.gl/myfTBrFwNAPMMrRq9";
    };

   const handleButtonClickevento = () => {
      window.location.href = "https://maps.app.goo.gl/RLWD58Jzh6gEjpLz5";
    };

    function addToGoogleCalendar() {
      const startDate = new Date('2025-11-15T20:00:20-05:00'); // Fecha de inicio del evento
      const endDate = new Date('2025-11-16T03:20:00-05:00'); // Fecha de fin del evento (1 día después)
      const eventTitle = 'Boda Betiana y Renzo'; // Título del evento
      const eventLocation = 'M&M EVENTOS, Ushuaia'; // Ubicación del evento
  
      // Generar la URL para añadir el evento a Google Calendar
      const eventUrl = encodeURI(`https://www.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate.toISOString().replace(/-|:|\.\d{3}/g, '')}/${endDate.toISOString().replace(/-|:|\.\d{3}/g, '')}&location=${eventLocation}`);
      
      // Abrir la URL en una nueva pestaña
      window.open(eventUrl, '_blank');
  }

    return (
      <div className="relative bg-cover bg-center bg-no-repeat bg-fixed" style={{ backgroundImage: `url(${require('../../Imagenes/5.png')})`}}>
          <div className="absolute inset-0 bg-white bg-opacity-50"></div>
        <div className="relative container mx-auto px-4 py-4">
          <div className="text-center">
            <h2 className="font-Libre-Baskerville text-verde1 text-3xl md:text-5xl mb-2">Dónde & Cuándo</h2>
            <p className="font-Libre-Baskerville text-verde1 text-2xl md:text-4xl">El 15 de Noviembre de 2025</p>
          </div>
          <Fade direction="top-right"> 
          <div className="text-center mt-8">
<button  className="font-bold text-lg md:text-xl py-3 px-8 bg-verde2 text-white rounded-md hover:bg-verde2 transition duration-300" onClick={addToGoogleCalendar}>  <FontAwesomeIcon icon={faCalendarDays} /> Agendar</button>
          </div></Fade>
        </div>
        
        <div className=" relative container mx-auto px-4 py-8 flex flex-wrap justify-between max-w-7xl">
        <div className="Ubicacion flex flex-col items-center justify-center text-white bg-white bg-opacity-60 p-8 rounded-xl shadow-lg border-4 border-verde1 w-full md:w-2/5 mb-4 md:mb-0">
            <h1 className="font-bold text-verde1 text-2xl md:text-3xl mb-2 md:mb-4">Ceremonia Religiosa</h1>
            <Fade cascade={true} duration={3000}>
            <FontAwesomeIcon icon={faChurch} className="anillos w-24 h-auto mb-2 md:mb-4 text-verde1" />
            </Fade>
            <p className="font-semibold text-lg text-verde1 md:text-xl mb-2 text-center">Iglesia Evangélica Bautista <br />  20:00hs</p>
            <Fade direction="top-left">  <button className="font-semibold text-lg md:text-xl py-2 px-4 bg-verde2 text-white rounded-md hover:bg-verde2 transition duration-300" onClick={handleButtonClick}>Cómo llegar</button>
         </Fade>
    </div>
  
          <div className="Ubicacion flex flex-col items-center justify-center bg-white bg-opacity-60 p-8 rounded-xl shadow-lg border-4 border-verde1 w-full md:w-2/5">
            <h1 className="font-bold text-2xl md:text-3xl text-verde1 mb-2 md:mb-4">Celebración</h1>
            <Fade cascade={true} duration={3000}>
            <FontAwesomeIcon icon={faChampagneGlasses} className="copas text-verde1 w-24 h-auto mb-2 md:mb-4" />
            </Fade>
            <p className="font-semibold text-lg md:text-xl text-verde1 mb-2 text-center">M&M EVENTOS <br />  21:30hs</p>
            <Fade direction="top-right"> <button className="font-semibold text-lg md:text-xl py-2 px-4 bg-verde2 text-white rounded-md hover:bg-verde2 transition duration-300" onClick={handleButtonClickevento}>Cómo llegar</button>
        </Fade>
          </div>
        </div>
      </div>
    );
    
  }
export default Ubicacion;  